import React from 'react';
import key from 'weak-key';
import { Link } from '@geberit/gdds';

// styles
import styles from './related-links.module.scss';

// utils
import { isEmpty } from 'utils/is-empty';
import { decodingContent } from 'utils/decodingContent';
import { Headline } from 'components/ContentElementsGdds/headline/headline';

export function LinksBlock({ linkBlock }: Readonly<{ linkBlock: LinkBlock }>) {
  const { links, title } = linkBlock;

  if (isEmpty(links)) {
    return null;
  }

  return (
    <div className={styles.block}>
      {title && <Headline tag="h4" variant="h6" title={decodingContent(title)} />}
      <nav>
        <ul className={styles.list}>
          {links.map((itemLink) => {
            itemLink.text = decodingContent(itemLink?.text?.slice(0, 90));

            return (
              <li key={key(itemLink)}>
                <Link hasArrow={itemLink.showArrow} stylingType="inverted" {...itemLink} />
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
}
